import React, { useEffect, useState } from 'react';
import styles from './Site.module.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router-dom';
import sitesData from '../../sites.json'; // Import your sites data
import { ClipLoader } from 'react-spinners'; // Import the spinner component

const Site = () => {
    const location = useLocation();
    const { link } = useParams(); // Get URL parameter
    const [siteData, setSiteData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Try to get site from location state first (when navigating from HomePage)
        const siteFromState = location.state?.site;
        
        if (siteFromState) {
            setSiteData(siteFromState);
            setLoading(false);
            return;
        }
        
        // If no state, find the site from sitesData based on URL parameter
        if (link) {
            const foundSite = sitesData.find(site => site.link === link);
            
            if (foundSite) {
                setSiteData(foundSite);
            }
            
            setLoading(false);
        }
    }, [location, link]);

    if (loading) return <div className={styles.spinnerContainer}><ClipLoader size={50} /></div>;
    if (!siteData) return <p>Site not found.</p>;

    return (
        <div>
            <Helmet>
                <title>Citizens of the Internet | Personal Website Gallery | {siteData.name}</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content={`${siteData.name} | Citizens of the Internet`} />
                <meta property="og:description" content={siteData.bio} />
                <meta property="og:image" content={siteData.og} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={siteData.og} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${siteData.name} | Citizens of the Internet`} />
                <meta name="twitter:description" content={siteData.bio} />
                <meta name="twitter:image" content={siteData.og} />
            </Helmet>
            <Nav />
            <section className={styles.siteFeature}>
                <div className={styles.siteFeatureCardContainer}>
                    <div className={styles.featureHeader}>
                        <div className={styles.headerTop}>
                            <img className={styles.pfp} src={siteData.pfp} alt={siteData.name} />
                            <div className={styles.headerText}>
                                <h1>{siteData.name}</h1>
                                <a href={siteData.url[0]} target="_blank" rel="noopener noreferrer">
                                    <button>Visit<img className={styles.arrow} src="../images/arrow-4.svg" alt="arrow" /></button>
                                </a>
                            </div>
                        </div>
                        <h4>{siteData.bio}</h4>
                    </div>
                    <div className={styles.categoryContainer}>
                        <p className={styles.categoryLabel}>CATEGORY</p>
                        <div className={styles.categoriesContainer}>
                            {siteData.category && siteData.category.map((category, index) => (
                                <p key={index} className={styles.siteCategory}>{category}</p>
                            ))}
                        </div>
                    </div>
                    <div className={styles.featuresContainer}>
                        <p className={styles.featuresLabel}>FEATURES</p>
                        <div className={styles.featuresCategoryContainer}>
                            {siteData.features && siteData.features.map((feature, index) => (
                                <p key={index} className={styles.featureCategory}>{feature}</p>
                            ))}
                        </div>
                    </div>
                    <div className={styles.platformContainer}>
                        <p className={styles.builtWithLabel}>BUILT WITH</p>
                        <div className={styles.builtWithContainer}>
                            <p className={styles.builtWithCategory}>{siteData.builtwith}</p>
                        </div>
                    </div>
                    <div className={styles.linkContainer}>
                        <p className={styles.urlLabel}>URL</p>
                        <div className={styles.urlContainer}>
                            <p className={styles.url}><a href={siteData.url[0]} target="_blank" rel="noopener noreferrer">{siteData.url[1]}</a></p>
                        </div>
                    </div>
                    <div className={styles.publishedContainer}>
                        <p className={styles.publishedLabel}>PUBLISHED</p>
                        <div className={styles.publishDateContainer}>
                            <p className={styles.publishDate}>{siteData.published}</p>
                        </div>
                    </div>
                    <div className={styles.uniqueIdContainer}>
                        <p className={styles.siteNumberLabel}>SITE ID</p>
                        <div className={styles.siteNumberContainer}>
                            <p className={styles.siteNumber}>{siteData.id}</p>
                        </div>
                    </div>
                    <div className={styles.screenshotImagesContainer}>
                        {siteData.images && siteData.images.map((image, index) => (
                            <div key={index} className={styles.screenshotContainer}>
                                <img className={styles.siteFeatureCardScreenshot} src={image} alt={`${siteData.name} screenshot ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Site;